/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { withTranslation } from 'react-i18next'
import { useHistory, useLocation } from 'react-router-dom'
import styles from './Navbar.module.scss'

const Navbar = ({ t, i18n }) => {
  const { pathname } = useLocation()
  let history = useHistory()
  const language = i18n.language
  const languageToggle = (e) => {
    try {
      const routes = t('routes', { returnObjects: true })
      let lang = e.currentTarget.text === 'English' ? 'en' : 'fr'
      const [, route] = pathname.split(i18n.language)
      const routeKey = Object.keys(routes).find((key) => routes[key] === route)
      if (routeKey) {
        i18n.changeLanguage(lang)
        const pushRoute = `/${lang}${t(`routes.${routeKey}`)}`
        document.getElementById('ApplicationTitle').innerHTML = t('title')
        document.getElementById('AppLanguage').lang = i18n.language
        history.push(pushRoute)
      }
    } catch (err) {
      console.log(err)
    }
  }

  return language === 'en' ? (
    <div>
      <nav id="navigation" className="ribbon" role="navigation" aria-label="Main navigation">
        <div className="container">
          <div className="row">
            <div className="col-xs-6">
              <a href="https://beta.novascotia.ca/pay-for-a-road-test" hrefLang="en" className="nsgov_flag_anchor">
                <img
                  className="ribbon-img"
                  src="https://novascotia.ca/clf/ignition/img/nsvip-en-white-flag.svg"
                  alt="Province of Nova Scotia"
                />
              </a>
            </div>
            <div className="col-xs-6">
              <div className={styles['anchors_float_left']}>
                <a onClick={languageToggle} className={styles['language_anchor']} tabIndex="0">
                  Français
                </a>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://support.novascotia.ca/services/pay-road-test"
                  className={styles['help_anchor']}
                >
                  Help
                </a>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </div>
  ) : language === 'fr' ? (
    <div>
      <nav id="navigation" className="ribbon" role="navigation" aria-label="Main navigation">
        <div className="container">
          <div className="row">
            <div className="col-xs-6">
              <a href="https://beta.novascotia.ca/fr/paiement-de-lexamen-de-conduite" hrefLang="fr" className="nsgov_flag_anchor">
                <img
                  className="ribbon-img"
                  style={{ width: '6.5em' }}
                  src="https://novascotia.ca/clf/ignition/img/nsvip-fr-white-flag.svg"
                  alt="Province of Nova Scotia"
                />
              </a>
            </div>
            <div className="col-xs-6">
              <div className={styles['anchors_float_left']}>
                <a onClick={languageToggle} className={styles['language_anchor']} tabIndex="0">
                  English
                </a>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://support.novascotia.ca/services/pay-road-test-fr"
                  className={styles['help_anchor']}
                >
                  Aide
                </a>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </div>
  ) : (
    ''
  )
}

export default withTranslation('common')(Navbar)
